export { default } from './Fifth';
